const storage = {
    not_configured: '未配置存储提供程序。',
    missing_parameter: '存储提供程序缺少参数 {{parameter}}。',
    upload_error: '无法将文件上传到存储提供程序。',
};
export default storage;
